import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { defaultContainerPropTypes } from 'moet-core';

import { SensitiveGoodsCards } from './SensitiveGoodsCards';

const SensitiveGoodsWrapper = ({ Container, ...props }) => <Container {...props} />;

SensitiveGoodsWrapper.propTypes = {
  ...defaultContainerPropTypes,
  Container: PropTypes.elementType.isRequired,
};

export const SensitiveGoods = connect(() => ({ Container: SensitiveGoodsCards }))(
  SensitiveGoodsWrapper,
);
